import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8f4ec8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "menuWrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "routerLinkText" }, "求人の出稿", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "routerLinkText" }, "社員インタビュー", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "routerLinkText" }, "アカウント設定", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apply_icon = _resolveComponent("apply-icon")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_microphone_icon = _resolveComponent("microphone-icon")!
  const _component_settings_icon = _resolveComponent("settings-icon")!
  const _component_Info = _resolveComponent("Info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_n_button, {
        text: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router('/hospital/apply_list'))),
        class: "routerLink"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_n_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_apply_icon)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_n_button, {
        text: "",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.router('/hospital/interview_list'))),
        class: "routerLink"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_n_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_microphone_icon)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_n_button, {
        text: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router('/hospital/accounts'))),
        class: "routerLink"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_n_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_settings_icon)
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_Info, { role: "hospital" })
  ], 64))
}